import $ from 'jquery';
import App from '../app.js';
import ScrollMagic from 'scrollmagic';
import OrbitHelper from './OrbitHelper.js';
var Orbit = function(options){
	var defaults = {
		duration: 2.5,
		onAnimateInComplete: null, // function
		onAnimateOutComplete: null // function
	};
	var settings = $.extend( {}, defaults, options );
	var $orbit = $(settings.selector);
	if( $orbit.length < 1 ) return false;
	var	$curve = $orbit.find('.js-curve'),
			$slider = $orbit.find('.js-slider'),
			scrollMagicController = App.getScrollMagicController(),
			enterScene,
			exitScene;

	createEnterScene();

	function createEnterScene() {

		// Set up Scroll Magic Scenes
		enterScene = new ScrollMagic.Scene({
			triggerElement: $orbit[0],
			triggerHook: "onEnter",
			duration: 0,
			offset: 0
		})
		.reverse(false)
		.addTo(scrollMagicController)
		// .addIndicators()
		.on('start', setEnterTween); // Create the tween when triggered
	}

	function createExitScene() {
		exitScene = new ScrollMagic.Scene({
			triggerElement: $orbit[0],
			triggerHook: "onLeave",
			duration: 0,
			offset: 0
		})
		.reverse(false)
		.addTo(scrollMagicController)
		// .addIndicators()
		.on('start', setExitTween);
	}

	function setEnterTween() {
		var tween = new TimelineMax({onComplete: timelineComplete})
					.add(TweenMax.to($slider, settings.duration, {
						opacity: 1,
						bezier: {
							values: OrbitHelper.getEnterBezierData($curve),
							curviness: 1.5
						},
						ease:Power2.easeOut
					}), 'enter')

					// .add(TweenMax.fromTo($slider, settings.duration * 0.5, { opacity: 0}, {opacity: 1, ease: Power2.easeOut}), 'enter');

		enterScene.setTween(tween);

		function timelineComplete() {
			tween.clear();
			tween.kill();
			TweenLite.set($slider, {clearProps:"all"});
			$slider.addClass('is-active');

			// Delete Enter Scene, Create Exit Scene
			// enterScene.destroy(true);
			// createExitScene();

			// Trigger callback if exists
			if (typeof settings.onAnimateInComplete === "function") settings.onAnimateInComplete($orbit);
		}
	}

	function setExitTween() {
		var tween = new TimelineMax({onComplete: timelineComplete})
			.add(TweenMax.to($slider, settings.duration, {
						opacity: 0,
						bezier: {
							values: OrbitHelper.getExitBezierData($curve),
							// values: getExitBezierData(),
							curviness: 1.5
						},
						ease: Power2.easeIn
					}), "exit" );


		exitScene.setTween(tween);

		function timelineComplete() {
			tween.clear();
			tween.kill();
			TweenLite.set($slider, {clearProps:"all"});
			$slider.removeClass('is-active');

			// Delete Exit Scene, Create Enter Scene
			exitScene.destroy(true);
			// createEnterScene();
			// Trigger callback if exists
			if (typeof settings.onAnimateOutComplete === "function") settings.onAnimateOutComplete($orbit);
		}
	}
};

export default Orbit;